/**
 * PATH: packages/email-hub/src/feature/pages/inboxComposeMode.ts
 * FILE_ID: EMAILHUB-FEATURE-PAGES-INBOXCOMPOSEMODE-001
 * PURPOSE: Canonical body of this email pages module. Lifted
 *          from apps/<tenant>/src/features/email/pages/inboxComposeMode.ts
 *          (see docs/architecture/EMAIL_KANBAN_CUTOVER_ARC.md).
 *          Tenants import this via thin re-export shims; edit
 *          THIS file, not the tenant copies.
 * WHY:     Removes operator-visible drift between tenants —
 *          previously every email feature change had to be
 *          mirrored manually in two tenant trees, and concurrent
 *          agents kept letting one side go stale. One canonical
 *          body, both tenants consume from this package.
 * RELATED:
 *   - apps/<tenant>/src/features/email/pages/inboxComposeMode.ts: thin re-export
 *     shim that points back here.
 */

import { emailPath } from '../lib/basePath'

/**
 * True when the given pathname is the email-hub compose route
 * (with or without a trailing slash). False for every other path.
 *
 * Base-path aware: matches against `emailPath('/compose')`, so it
 * works on every host mount point — `/emails/compose` (master),
 * `/email/compose` (SAM), `/compose` (standalone hub). Previously a
 * hard-coded `/email/compose` regex returned false on master, so the
 * inbox never recognised it was in compose mode.
 *
 * Examples (SAM default base `/email`):
 *   isComposePath('/email/compose')        → true
 *   isComposePath('/email/compose/')       → true
 *   isComposePath('/email/inbox')          → false
 *   isComposePath('/email/compose?reply=1')→ false (search not part of pathname)
 *   isComposePath('/email/composer-x')     → false
 *   isComposePath('')                      → false
 */
export function isComposePath(pathname: string | null | undefined): boolean {
  if (!pathname) return false
  const base = emailPath('/compose')
  return pathname === base || pathname === `${base}/`
}
